import React from 'react';
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";

const CommentatorSelect = ({ list, name, onChange, title, value }) => {
    return (
        <FormControl size="small" sx={{ width: "100%", height: "35px", boxSizing: "border-box", marginBottom: "1rem"}}>
            <InputLabel id="demo-simple-select-label">{title}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={title}
                onChange={onChange}
                name={name}
                value={value || ''}
            >
                {list.map((comm, index) => (
                    <MenuItem key={comm.id} value={comm.id}>{comm.name}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default CommentatorSelect;